import { Box, Chip, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import NumberSpinner from './NumberSpinner';
import { registrationStyles } from './eventDetailsStyles';
import { formatCurrency } from './eventDetailsUtils';

const TicketCard = ({ ticket, selected, available, seatsLabel, quantity, quantityLimit, formErrors, onSelect, onQuantityChange }) => (
  <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
    <Box
      role="button"
      tabIndex={available ? 0 : -1}
      aria-selected={selected}
      aria-disabled={!available}
      onClick={(event) => {
        event.stopPropagation();
        onSelect(ticket);
      }}
      onKeyDown={(event) => {
        if (!available || (event.key !== 'Enter' && event.key !== ' ')) return;
        event.preventDefault();
        event.stopPropagation();
        onSelect(ticket);
      }}
      sx={registrationStyles.ticketCard(selected, available)}
    >
      <Stack spacing={1.25} sx={{ height: '100%' }}>
        <Stack direction="row" spacing={1} alignItems="center" useFlexGap sx={{ flexWrap: 'wrap' }}>
          <Typography sx={{ fontWeight: 800, lineHeight: 1.25 }}>{ticket.label}</Typography>
          {!available && <Chip size="small" label="Sold out" color="error" />}
        </Stack>
        {ticket.description && <Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1 }}>{ticket.description}</Typography>}
        <Stack spacing={0.75} sx={{ mt: 'auto' }}>
          {seatsLabel && <Chip label={seatsLabel} sx={{ alignSelf: 'flex-start' }} />}
          <Typography sx={{ fontWeight: 900 }}>{formatCurrency(ticket.price)}</Typography>
        </Stack>
        {selected && (
          <Box sx={registrationStyles.ticketQuantity}>
            <NumberSpinner
              label="Quantity"
              min={1}
              max={quantityLimit ?? undefined}
              value={quantity}
              onChange={onQuantityChange(ticket)}
              disabled={!available}
              error={Boolean(formErrors.quantity)}
              helperText={formErrors.quantity}
            />
          </Box>
        )}
      </Stack>
    </Box>
  </Grid>
);

export default TicketCard;
